import { render } from "./SettingsBilling.vue?vue&type=template&id=2b4c470f&scoped=true"
import script from "./SettingsBilling.vue?vue&type=script&lang=js"
export * from "./SettingsBilling.vue?vue&type=script&lang=js"

import "./SettingsBilling.vue?vue&type=style&index=0&id=2b4c470f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4c470f"]])

export default __exports__